import { render, staticRenderFns } from "./CVView.vue?vue&type=template&id=8ec4f0d6&"
import script from "./CVView.vue?vue&type=script&lang=js&"
export * from "./CVView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports